export default __webpack_public_path__ + "static/media/photo_tigers-season-2020.2dbd37e5.jpg";